<template>
  <div class="fast-body-modo-aluno">
    <!-- fd-wrap -->
    <div class="fd-app-wrap">
      <div class="container fast-plataforma-iuea-hide">
        <!-- breadcrumb -->
        <nav>
          <ul class="fd-app-breadcrumb mb-0">
            <li class="fd-app-breadcrumb-item">
              <a href="/minhas-plataformas" class="aluno_font_color"
                @click.prevent="$router.push('/minhas-plataformas')">Minhas Plataformas</a>
            </li>
            <li class="fd-app-breadcrumb-item">
              <a :href="'/plataforma/' + $route.params.id_plataforma" class="aluno_font_color"
                @click.prevent="$router.push('/plataforma/' + $route.params.id_plataforma)">Plataforma {{
                  $store.state.fastPlataforma.nome_plataforma }}</a>
            </li>
            <li class="fd-app-breadcrumb-item">
              <a class="aluno_font_color" :href="'/plataforma/' + $route.params.id_plataforma + '/aluno'"
                @click.prevent="$router.push('/plataforma/' + $route.params.id_plataforma + '/aluno')">Modo aluno</a>
            </li>
            <li class="fd-app-breadcrumb-item">
              <a class="aluno_font_color" :href="'/plataforma/' + $route.params.id_plataforma + '/aluno/secretaria'"
                @click.prevent="$router.push('/plataforma/' + $route.params.id_plataforma + '/aluno/secretaria')">Secretaria</a>
            </li>
            <li class="fd-app-breadcrumb-item active">
              <a href="#">Meus documentos</a>
            </li>
          </ul>
        </nav>
        <!-- /breadcrumb -->
      </div>
      <div class="fd-mode-ead-content mt-0">
        <div class="container">
          <div class="row justify-content-center">
            <div class="col-sm-12 col-md-12 col-lg-12">
              <div class="mt-3 mb-4">
                <a class="btn-novo btn-red-hollow-novo"
                  :href="'/plataforma/' + $route.params.id_plataforma + '/aluno/secretaria'"
                  @click.prevent="$router.push('/plataforma/' + $route.params.id_plataforma + '/aluno/secretaria')">
                  <b-icon-arrow-return-left /> Voltar
                </a>
              </div>
              <!-- fd-app-welcome -->
              <section class="fd-app-welcome-novo text-left fast-plataforma-iuea-hide mt-2">
                <h2 class="aluno_font_color mb-0">
                  Meus <span>Documentos</span>
                </h2>
                <p class="aluno_font_color my-0">Acompanhe seus documentos!</p>
                <div>
                  <img :src="require('@/assets/images/separador.png')
                    " />
                </div>
              </section>
              <!-- /fd-app-welcome -->
              <!-- fd-mode-opcoes -->
              <section class="col-md-12 col-sm-12 col-lg-5 fd-mode-opcoes fd-mode-ead">
                <!-- meu contrato -->
                <a :href="'/plataforma/' + $route.params.id_plataforma + '/aluno/secretaria/meus-documentos'"
                  class="row btn-menu btn-menu-blue p-2 mb-4" @click.prevent="exibeModalContrato()">
                  <img class="ml-3" style="max-height: 50px;"
                    :src="require('@/assets/images/app/meu-contrato.png')">
                  <h2 class="col-8 font-weight-normal">MEU CONTRATO</h2>
                </a>
                <!-- meu historico escolar -->
                <a :href="'/plataforma/' + $route.params.id_plataforma + '/aluno/secretaria/meus-documentos'"
                  class="row btn-menu btn-menu-blue p-2 mb-4" @click.prevent="exibeModalHistorico()">
                  <img class="ml-3" style="max-height: 50px;"
                    :src="require('@/assets/images/app/meu-historico.png')">
                  <h2 class="col-8 font-weight-normal">MEU HISTÓRICO ESCOLAR</h2>
                </a>
                <!-- meu certificado -->
                <a :href="'/plataforma/' + $route.params.id_plataforma + '/aluno/secretaria/meus-documentos'"
                  class="row btn-menu btn-menu-blue p-2 mb-4" @click.prevent="exibeModalCertificado()">
                  <img class="ml-3" style="max-height: 50px;"
                    :src="require('@/assets/images/app/meu-certificado.png')">
                  <h2 class="col-8 font-weight-normal">MEU CERTIFICADO</h2>
                </a>
              </section>
              <!-- /fd-mode-opcoes -->
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- /fd-wrap -->
    <!-- Modals -->
    <modal name="modalMeuContrato" class="modal-table-novo" :shift-y="0.1" height="auto" :width="modalWidthLg" :scrollable="true"
      :adaptative="true">
      <div class="row fd-app-table-novo">
        <div class="col-12 d-flex justify-content-between">
          <div class="pl-3 pt-2">
            <h4>Meu Contrato</h4>
          </div>
          <div class="pr-3 pt-2">
            <a class="btn-novo btn-light" href="#" @click.prevent="hideModal('modalMeuContrato')">
              <b-icon-arrow-return-left class="text-orange"/>
            </a>
          </div>
        </div>
        <div class="col-12 table-responsive">
          <table class="table table-sm text-nowrap">
            <thead>
              <tr>
                <th class="text-center">
                  Matrícula
                </th>
                <th class="text-center">
                  Data
                </th>
                <th class="text-center">
                  Nível
                </th>
                <th class="text-center">
                  Turma
                </th>
                <th class="text-center">
                  Plano
                </th>
                <th class="text-center">
                  Ação
                </th>
              </tr>
            </thead>
            <tbody v-if="fastMatriculasAluno.length">
              <tr v-for="(matricula, index) in fastMatriculasAluno" :key="index">
                <td class="text-center">
                  #{{ matricula.id_matricula }}
                </td>
                <td class="text-center">
                  <span v-if="matricula.data_matricula">{{ formataDataT(matricula.data_matricula) }}</span>
                </td>
                <td class="text-center">
                  {{
                    retornaCursoNivel(matricula.nivel)
                  }}
                </td>
                <td class="text-center">
                  {{ matricula.sigla_turma }}
                </td>
                <td class="text-center">
                  <span v-if="matricula.matricula_por_programa
                    ">{{ matricula.qtde_modulos_compra }}
                    módulo(s)</span>
                  <span v-else-if="matricula.matricula_por_unidade
                    ">{{ matricula.qtde_unidades_compra }}
                    unidade(s)</span>
                  <span v-else>Curso completo</span>
                </td>
                <td class="text-center">
                  <a v-if="matricula.path_contrato" class="btn-novo btn-sm btn-primary pt-0 pb-0 mr-2" 
                    :href="ajustaLinkApiAntiga(matricula.path_contrato)" target="_blank"
                  >
                    <small class="text-light"><b-icon-download/> Baixar contrato</small>
                  </a>
                  <a href="#" v-else class="btn-novo btn-sm btn-disable-novo pt-0 pb-0 mr-2"
                    @click.prevent="exibeToasty('Contrato indisponível para este curso', 'error')">
                    <small class="text-light"><b-icon-exclamation-diamond/> Contrato indisponível</small>
                  </a>
                </td>
              </tr>
            </tbody>
            <tbody v-else>
              <tr>
                <td colspan="8" class="text-center">
                  <span>Nenhuma matrícula cadastrada</span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </modal>
    <modal name="modalMeuHistorico" class="modal-table-novo" :shift-y="0.1" height="auto" :width="modalWidthLg" :scrollable="true"
      :adaptative="true">
      <div class="row fd-app-table-novo">
        <div class="col-12 d-flex justify-content-between">
          <div class="pl-3 pt-2">
            <h4>Meu Histórico Escolar</h4>
          </div>
          <div class="pr-3 pt-2">
            <a class="btn-novo btn-light" href="#" @click.prevent="hideModal('modalMeuHistorico')">
              <b-icon-arrow-return-left class="text-orange"/>
            </a>
          </div>
        </div>
        <div class="col-12 table-responsive">
          <table class="table table-sm text-nowrap">
            <thead>
              <tr>
                <th>
                  <small class="font-weight-bold">Nome do curso</small>
                </th>
                <th>
                  <small class="font-weight-bold">Nível</small>
                </th>
                <th class="text-center">
                  <small class="font-weight-bold">Carga horária</small>
                </th>
                <th class="text-center">
                  <small class="font-weight-bold"></small>
                </th>
              </tr>
            </thead>
            <tbody v-if="fastHistoricoSecretariaCursos.loading">
              <b-icon icon="gear-fill" animation="spin" /> Carregando
            </tbody>
            <tbody v-else-if="fastHistoricoSecretariaCursos.total.length">
              <tr v-for="curso in fastHistoricoSecretariaCursos.total" :key="curso.id_secretaria_curso">
                <td class="align-middle">
                  <small>
                    {{ curso.nome_curso }}
                  </small>
                </td>
                <td class="align-middle">
                  <small>{{ retornaCursoNivel(curso.nivel) }}</small>
                </td>
                <td class="align-middle text-center">
                  <span v-if="curso.carga_horaria">
                    <small>{{ curso.carga_horaria }}h</small>
                  </span>
                </td>
                <td class="text-center">
                  <a href="#" class="btn-novo btn-sm btn-primary pt-0 pb-0 mr-2"
                    @click.prevent="exibeModalHistoricoSecretariaCurso(curso)">
                    <small class="text-light"><b-icon-download/> Baixar histórico</small>
                  </a>
                </td>
              </tr>
            </tbody>
            <tbody v-else>
              <tr>
                <td colspan="4" class="text-center">
                  <span>Nenhum histórico encontrado</span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </modal>
    <modal name="modalMeuCertificado" class="modal-table-novo" :shift-y="0.1" height="auto" :width="modalWidthLg" :scrollable="true"
      :adaptative="true">
      <div class="row fd-app-table-novo">
        <div class="col-12 d-flex justify-content-between">
          <div class="pl-3 pt-2">
            <h4>Meu Certificado</h4>
          </div>
          <div class="pr-3 pt-2">
            <a class="btn-novo btn-light" href="#" @click.prevent="hideModal('modalMeuCertificado')">
              <b-icon-arrow-return-left class="text-orange"/>
            </a>
          </div>
        </div>
        <div class="col-12 table-responsive">
          <table class="table table-sm text-nowrap">
            <thead>
              <tr>
                <th>
                  <small class="font-weight-bold">Nome do curso</small>
                </th>
                <th>
                  <small class="font-weight-bold">Nível</small>
                </th>
                <th class="text-center">
                  <small class="font-weight-bold">Carga horária</small>
                </th>
                <th class="text-center">
                  <small class="font-weight-bold"></small>
                </th>
              </tr>
            </thead>
            <tbody v-if="fastHistoricoSecretariaCursos.loading">
              <b-icon icon="gear-fill" animation="spin" /> Carregando
            </tbody>
            <tbody v-else-if="fastHistoricoSecretariaCursos.total.length">
              <tr v-for="curso in fastHistoricoSecretariaCursos.total" :key="curso.id_secretaria_curso">
                <td class="align-middle">
                  <small>
                    {{ curso.nome_curso }}
                  </small>
                </td>
                <td class="align-middle">
                  <small>{{ retornaCursoNivel(curso.nivel) }}</small>
                </td>
                <td class="align-middle text-center">
                  <span v-if="curso.carga_horaria">
                    <small>{{ curso.carga_horaria }}h</small>
                  </span>
                </td>
                <td class="text-center">
                  <a href="#" v-if="curso.gera_certificado" class="btn-novo btn-sm btn-primary pt-0 pb-0 mr-2"
                    @click="gerarCertificadoConclusao(curso)">
                    <small class="text-light"><b-icon-download/> Baixar certificado</small>
                  </a>
                  <a href="#" v-else class="btn-novo btn-sm btn-disable-novo pt-0 pb-0 mr-2"
                    @click.prevent="exibeToasty('O curso não está configurado para gerar certificado', 'error')">
                    <small class="text-light"><b-icon-exclamation-diamond/> Certificado Indisponível</small>
                  </a>
                </td>
              </tr>
            </tbody>
            <tbody v-else>
              <tr>
                <td colspan="4" class="text-center">
                  <span>Nenhum histórico encontrado</span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </modal>
    <!-- PDF region -->
    <VueHtml2pdf ref="html2PdfHistorico" class="mx-auto" :show-layout="false" :float-layout="true"
      :enable-download="false" :preview-modal="true" :html-to-pdf-options="htmlToPdfOptions" pdf-content-width="955px"
      :manual-pagination="false" :paginate-elements-by-height="10000">
      <section slot="pdf-content">
        <div class="fast-pdf-html-template" v-html="boletim_html_template">
        </div>
      </section>
    </VueHtml2pdf>
    <vue-html2pdf ref="html2PdfCertificado" :show-layout="false" :float-layout="true" :enable-download="false"
      :preview-modal="true" :paginate-elements-by-height="1600" filename="hee hee" :pdf-quality="2"
      :manual-pagination="false" pdf-format="a4" pdf-orientation="landscape" pdf-content-width="100%">
      <section slot="pdf-content">
        <div class="row">
          <div class="col-12" v-html="htmlCertificado"></div>
        </div>
      </section>
    </vue-html2pdf>
  </div>
</template>

<script>
import { settings } from "@/config";
import methods from "@/methods";
import VueHtml2pdf from "vue-html2pdf"; //https://www.npmjs.com/package/vue-html2pdf

export default {
  name: "HomeInternoAlunoSecretariaDocumentos",
  components: {
    VueHtml2pdf 
  },
  mixins: [methods],
  data: function () {
    return {
      fastTemplate: settings.fastTemplate,
      modalWidthSm: this.isMobile() ? "80%" : "30%",
      modalWidthMd: this.isMobile() ? "100%" : "50%",
      modalWidthLg: this.isMobile() ? "100%" : "90%",
      // Ranking
      fastRanking: [],
      fastUsuarioRanking: {
        id_plataforma: 0,
        imagem_nivel: "",
        nivel: "",
        nome_nivel: "",
        ponto_final: "",
        ponto_inicial: "",
        pontos_usuario: "",
        status: "",
      },
      fastRankingParametros: {
        id_plataforma: 0,
        id_ranking_parametro: "",
        ponto_acerto_questao_quiz: 0,
        ponto_atividade_geral: 0,
        ponto_completar_curso: 0,
        ponto_completar_curso_acima_media: 0,
        ponto_completar_matriz: 0,
        ponto_completar_prova: 0,
        ponto_completar_prova_acima_media: 0,
        ponto_erro_questao_quiz: 0,
        ponto_participar_live: 0,
      },
      //#region Vars Histórico
      fastHistoricoSecretariaCursos: {
        total: [],
        loading: true
      },
      boletim_html_template: '<div class="row"><div class="col-sm-12 col-md-12 col-lg-9"><div class="row"><div class="col-12"><div class="text-center p-4 border border-2 border-secondary"><h3>Extrato de Notas e Faltas Parcial</h3></div></div></div></div><div class="col-sm-12 col-md-12 col-lg-3">%img_logo_plataforma%</div><div class="col-sm-12 col-md-12 col-lg-12 mt-4"><div class="row"><div class="col-sm-12 col-md-12 col-lg-8"><span>Nome: <b>%nome_aluno%</b></span></div><div class="col-sm-12 col-md-12 col-lg-4"><span>CPF: <b>%cpf_aluno%</b></span></div></div><div class="row"><div class="col-sm-12 col-md-12 col-lg-4"><span>Nacionalidade: <b>%nacionalidade_aluno%</b></span></div><div class="col-sm-12 col-md-12 col-lg-4"></div><div class="col-sm-12 col-md-12 col-lg-4"><span>Nascimento: <b>%nascimento_aluno%</b></span></div></div><hr class="mt-2 mb-2"><div class="row"><div class="col-sm-12 col-md-12 col-lg-12"><span>Curso: <b>%nome_curso%, %nivel_curso%</b></span></div></div><div class="row"><div class="col-sm-12 col-md-12 col-lg-12"><span>%descricao_legal%</span></div></div><div class="row"><div class="col-12 table-responsive mt-4"><table class="table"><thead><tr><th scope="col">ANO</th><th scope="col">DISCIPLINA</th><th scope="col">FALTAS POSSÍVEIS</th><th scope="col">FALTAS</th><th scope="col">CH</th><th scope="col">NOTA</th><th scope="col">SITUAÇÃO</th></tr></thead><tbody>%tbody_boletim%</tbody></table></div></div></div></div>',
      // Matrícula
      fastMatriculaAluno: {
        id_matricula: "",
        id_pessoa_aluno: 0,
        tipo_matricula: "",
        data_matricula: "",
        RA: "",
        id_usuario_cadastro: "",
        ano_matricula: "",
        valor_matricula: "",
        vencimento_matricula: "",
        url_boleto: "",
        pago: null,
        data_pagto: null,
        desconto_matricula: "",
        outros_valores: "",
        path_contrato: "",
        ativo: "",
        id_programa_turma: "",
      },
      fastMatriculaAlunoEditar: {
        id_matricula: "",
        id_pessoa_aluno: 0,
        tipo_matricula: "",
        data_matricula: "",
        RA: "",
        id_usuario_cadastro: "",
        ano_matricula: "",
        valor_matricula: "",
        vencimento_matricula: "",
        url_boleto: "",
        pago: null,
        data_pagto: null,
        desconto_matricula: "",
        outros_valores: "",
        path_contrato: "",
        ativo: "",
        id_programa_turma: "",
        id_secretaria_curso: 0,
        path_inscricao: ""
      },
      fastMatriculasAluno: [],
      fastExibirOpcoesContrato: false,
      fastSecretariaContratosCurso: [],
      fastContratoEscolhido: {
        id_contrato: "",
        html_template: "",
      },
      fastHistoricoNovo: {
        id_aluno_historico: 0,
        ano: 2023,
        periodo: "A",
        id_secretaria_curso: 0,
        id_turma: 0,
        id_secretaria_curso_programa: 0,
        carga_horaria: 0,
        dias_letivos: 0,
        faltas: 0,
        id_tipo_resultado_aluno: 0,
        id_pessoa: 0,
        tipo_avaliacao: "N",
        nota_maxima: 10,
        nro_decimais: 2,
        turno: "M",
        forma_carga_horaria: "",
        nota_aprovacao: 7,
        frequencia: 70,
        id_plataforma: 0,
        id_pessoa_aluno: 0,
        carregando_acao: false,
        unidades: []
      },
      fastHistoricoEditar: {
        id_aluno_historico: 0,
        ano: "",
        periodo: "A",
        id_secretaria_curso: 0,
        id_turma: "",
        id_secretaria_curso_programa: 0,
        carga_horaria: 0,
        dias_letivos: 0,
        faltas: 0,
        id_tipo_resultado_aluno: "",
        id_pessoa: 0,
        tipo_avaliacao: "N",
        nota_maxima: 10,
        nro_decimais: 2,
        turno: "M",
        forma_carga_horaria: "",
        nota_aprovacao: 7,
        frequencia: 70,
        id_plataforma: 0,
        id_pessoa_aluno: 0,
        carregando_acao: false,
        unidades: []
      },
      fastPlataformaAlunoResponsaveis: [],
      fastSecretariaCursos: {
        total: [],
        loading: true
      },
      fastSecretariaTurmas: {
        total: [],
        loading: true
      },
      fastSecretariaCursoModulos: {
        total: [],
        loading: true
      },
      fastResultados: {
        total: [],
        loading: true
      },
      fastPessoasParceiros: {
        total: [],
        loading: true
      },
      fastCursosPrograma: {
        total: [],
        loading: true
      },
      fastHistoricoUnidade: {
        id_curso: 0,
        nome_curso: "",
        nome_curso_mae: ""
      },
      fastHistoricoAluno: [],
      fastAproveitamentoAluno: {
        total: [],
        loading: true
      },
      //#enregion
      //#region Var certificado
      htmlCertificado: `
<div class="fast-template-certificado-html">
    <div class="fast-template-certificado-body">
        <div class="fast-template-certificado-container">
            <div class="row">
              <div class="col-2">
                <img class="img-responsive" src="data:image/gif;base64,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">
              </div>
              <div class="col-8">
                <div>REPÚBLICA FEDERATIVA DO BRASIL</div>
                <div>%nome_plataforma%</div>

                <div class="fast-template-certificado-marquee">
                  CERTIFICADO
                </div>
              </div>   
              <div class="col-2">
                %img_logo_plataforma%
              </div> 
              
            </div>
            

            <div class="fast-template-certificado-assignment">
                <small>A plataforma %nome_plataforma% licenciada sob a portaria %descricao_legal% confere a %nome_aluno% %nacionalidade_aluno%, CPF %cpf_aluno%, %naturalidade_aluno% , nascida no dia %nascimento_aluno%  o presente certificado, por haver concluído o curso</small>
            </div>

            <div class="fast-template-certificado-marquee">
                %nome_curso%
            </div>
            
            <div class="fast-template-certificado-assignment text-right">
              <small><p>%cidade_empresa%, ___________ de _________________ de ${new Date().getFullYear()}</p></small>
            </div>

            <br>

            <div class="row mt-4">
              <div class="col-6">
                <div class="fast-template-certificado-person">
                  Concluinte
                </div>
              </div>
              <div class="col-6">
                <div class="fast-template-certificado-person">
                  Diretor
                </div>
              </div> 
            </div>
        </div>
    </div>
</div>

<div class="fast-template-certificado-html">
  <div class="fast-template-certificado-body">
    <div class="fast-template-certificado-container" style="vertical-align: text-top">      
      <div class="row">
        <div class="col-12 p-4">
          <div class="row">
            <div class="col-12">
              %img_logo_plataforma%
            </div>
            <div class="col-12">
              <h3>Plataforma %nome_plataforma%</h3>
            </div>
            <br>
            <div class="col-12 mt-4">
              <div>%logradouro_empresa%, n. %numero_empresa% - %complemento_empresa% %cidade_empresa%-%uf_empresa%</div>
              <div>%email_empresa% - Tel. %telefone_empresa%</div>
            </div>
            <br>
            <div class="col-12 mt-4">
              <div><b>Observações:</b> ___________________________________________________ </div>
              <div>______________________________________________________________ </div>
              <div>______________________________________________________________ </div>
              <div>______________________________________________________________ </div>
            </div>
            
            <br>
            <div class="col-12 mt-4">
              <div><b>REGISTRO:</b> _________________ </div>
              <div>%cidade_empresa%, ___________ de _________________ de ${new Date().getFullYear()}</div>
            </div>
            
          </div>
        </div>
      </div>
    </div>
</div>
</div>
`,
      fastSecretariaCertificadoCurso: {
        id_secretaria_curso: 0,
        nome_curso: "",
        detalhe_curso: "",
        publicado: "",
        carga_horaria: "",
        logo_curso: "",
        id_plataforma: 0,
        creditos_total: "",
        nivel: "F",
        preco: 0,
        venda_modulo: "",
        venda_unidade_curricular: "",
        gera_certificado: "",
        possui_aproveitamento: "",
        id_base_curricular: 0,
        loja_virtual: false,
        descricao_legal: ''
      },
      // Invoice
      fastTesourariaInvoice: {
        id_plataforma: 0,
        id_invoice: "",
        data_registro: "",
        id_usuario_gerou: "",
        id_matricula: "",
        nome_aluno: "",
        nome_responsavel: "",
        cpf_responsavel: "",
        cpf_aluno: "",
        cep_responsavel: "",
        endereco_responsavel_numero: "",
        endereco_responsavel_complemento: "",
        subtotal: 0.0,
        desconto_total: 0.0,
        acrescimo: 0.0,
        total: 0.0,
        ativo: "",
        cancelado: "",
        motivo_cancelamento: "",
        id_usuario_cancelamento: "",
        data_cancelamento: "",
        obs: "",
        id_plano_pagamento: "",
        taxa_boleto: 0.0,
        taxa_cartao: 0.0,
        outras_taxas: 0.0,
        parcelas: [],
      },
      //#endregion

      // Pdf Configs
      htmlToPdfOptions: {
        margin: 0.5,
        filename: 'Contrato.pdf',
        image: {
          type: 'jpeg',
          quality: 1
        },
        enableLinks: false,
        html2canvas: {
          scale: 2,
          scrollX: 0,
          scrollY: 0,
          useCORS: true,
          width: 960,
        },
        jsPDF: {
          unit: 'in',
          format: 'a4',
          orientation: 'portrait'
        },
      },
    };
  },

  mounted: function () {
    // Captura ID da plataforma pela URL
    if (this.$route.params.id_plataforma) {
      this.getFastDependecias(this.$route.params.id_plataforma, 'aluno')
        .then(() => {
          this.$store.state.fastCarregando = false;

          // Se foi personalizado aplica cor nos textos
          if (this.$store.state.fastPersonalizacao.aluno_font_color) {
            Array.from(document.querySelectorAll(".aluno_font_color")).forEach((e) => (e.style.color = this.$store.state.fastPersonalizacao.aluno_font_color));
          }
          // Se foi personalizado aplica cor nos textos dos menus
          if (this.$store.state.fastPersonalizacao.menu_font_color) {
            Array.from(document.querySelectorAll(".menu_font_color")).forEach((e) => (e.style.color = this.$store.state.fastPersonalizacao.menu_font_color));
          }
          this.getFastMatriculaAluno(
            this.$route.params.id_plataforma,
            this.$store.state.fastPermissoes.id_pessoa
          );
          this.getHistoricoSecretariaCursos(this.$route.params.id_plataforma, this.$store.state.fastPermissoes.id_pessoa);
        })
        .catch((e) => {
          this.exibeToasty(e, "error");
          this.$store.state.fastCarregando = false;
        });

    }
  },

  methods: {
    exibeModalContrato() {
      this.showModal('modalMeuContrato')
    },
    exibeModalHistorico() {
      this.showModal('modalMeuHistorico')
    },
    exibeModalCertificado() {
      this.showModal('modalMeuCertificado')
    },
    async getFastMatriculaAluno(id_plataforma, id_pessoa_aluno) {
      this.promiseGetFastApi(
        "api/fast_secretaria_matricula_aluno/lista",
        "id_plataforma=" +
        id_plataforma +
        "&id_programa=0&id_pessoa_aluno=" +
        id_pessoa_aluno
      )
        .then((obj) => {
          if (obj.length) {
            this.fastMatriculasAluno = obj;
            // console.log(this.fastMatriculasAluno.path_contrato)
            this.fastPessoaReadOnly = true
          }
          else {
            this.fastMatriculasAluno = [];
            this.fastPessoaReadOnly = false
          }
        })
        .catch((e) => {
          console.log(e);
        });
    },
    getSecretariaContratosCurso(id_plataforma, id_secretaria_curso) {
      this.promiseGetFastApi(
        "api/fast_secretaria_contrato/lista_curso",
        "id_plataforma=" +
        id_plataforma +
        "&id_secretaria_curso=" +
        id_secretaria_curso
      )
        .then((obj) => {
          console.log("getSecretariaContratos", obj);
          if (obj.length) {
            this.fastSecretariaContratosCurso = obj;
            this.fastContratoEscolhido.id_contrato = obj[0].id_contrato;
          }
        })
        .catch((e) => {
          console.log(e);
        });
    },
    async getHistoricoSecretariaCursos(id_plataforma, id_pessoa_aluno) {
      // console.log(id_plataforma)
      // console.log(id_pessoa_aluno)
      this.fastHistoricoSecretariaCursos.loading = true
      this.promiseGetFastApi
        ("api/fast_secretaria_curso/lista_aluno", `id_plataforma=${id_plataforma}&id_pessoa_aluno=${id_pessoa_aluno}`)
        .then(res => {
          this.fastHistoricoSecretariaCursos.total = res
          this.fastHistoricoSecretariaCursos.loading = false
          // console.log(res)
        })
        .catch(e => {
          this.exibeToasty(e, "error")
          this.fastHistoricoSecretariaCursos.loading = false
        })
    },
    exibeModalHistoricoSecretariaCurso(fast_secretaria_curso) {
      // console.log(fast_secretaria_curso)
      // console.log(this.$store.state.fastPermissoes.id_pessoa)
      let erros = []
      // Reseta template
      this.boletim_html_template = '<div class="row"><div class="col-sm-12 col-md-12 col-lg-9"><div class="row"><div class="col-12"><div class="text-center p-4 border border-2 border-secondary"><h3>Extrato de Notas e Faltas Parcial</h3></div></div></div></div><div class="col-sm-12 col-md-12 col-lg-3">%img_logo_plataforma%</div><div class="col-sm-12 col-md-12 col-lg-12 mt-4"><div class="row"><div class="col-sm-12 col-md-12 col-lg-8"><span>Nome: <b>%nome_aluno%</b></span></div><div class="col-sm-12 col-md-12 col-lg-4"><span>CPF: <b>%cpf_aluno%</b></span></div></div><div class="row"><div class="col-sm-12 col-md-12 col-lg-4"><span>Nacionalidade: <b>%nacionalidade_aluno%</b></span></div><div class="col-sm-12 col-md-12 col-lg-4"></div><div class="col-sm-12 col-md-12 col-lg-4"><span>Nascimento: <b>%nascimento_aluno%</b></span></div></div><hr class="mt-2 mb-2"><div class="row"><div class="col-sm-12 col-md-12 col-lg-12"><span>Curso: <b>%nome_curso%, %nivel_curso%</b></span></div></div><div class="row"><div class="col-sm-12 col-md-12 col-lg-12"><span>%descricao_legal%</span></div></div><div class="row"><div class="col-12 table-responsive mt-4"><table class="table"><thead><tr><th scope="col">ANO</th><th scope="col">DISCIPLINA</th><th scope="col">FALTAS POSSÍVEIS</th><th scope="col">FALTAS</th><th scope="col">CH</th><th scope="col">NOTA</th><th scope="col">SITUAÇÃO</th></tr></thead><tbody>%tbody_boletim%</tbody></table></div></div></div></div>';
      let contrato = this.boletim_html_template;
      this.$store.state.fastCarregando = true
      this.promiseGetFastApi("api/fast_plataforma_usuario/busca_pessoa_secretaria", "id_pessoa=" + this.$store.state.fastPermissoes.id_pessoa + "&id_plataforma=" + this.$route.params.id_plataforma)
        .then(obj => {
          let objPessoa = JSON.parse(obj)
          // console.log("objPessoa", objPessoa)
          if (objPessoa.id_pessoa) {
            if (this.boletim_html_template.indexOf("%nome_aluno%") != "-1" && !objPessoa.nome_razao) erros.push("O nome do aluno não foi cadastrado")
            if (this.boletim_html_template.indexOf("%nome_aluno%") != "-1" && !objPessoa.sobrenome_fantasia) erros.push("O sobrenome do aluno não foi cadastrado")
            if (this.boletim_html_template.indexOf("%cpf_aluno%") != "-1" && !objPessoa.cpf_cnpj) erros.push("O CPF do aluno não foi cadastrado")
            if (this.boletim_html_template.indexOf("%naturalidade_aluno%") != "-1" && !objPessoa.cidade) erros.push("O cidade do aluno não foi cadastrada")
            if (this.boletim_html_template.indexOf("%naturalidade_aluno%") != "-1" && !objPessoa.uf) erros.push("O estado do aluno não foi cadastrado")
            if (this.boletim_html_template.indexOf("%nascimento_aluno%") != "-1" && !objPessoa.datanascimento_abertura) erros.push("A data de nascimento do aluno não foi cadastrada")
            if (this.boletim_html_template.indexOf("%nome_curso%") != "-1" && !fast_secretaria_curso.nome_curso) erros.push("O nome do curso não foi identificado")
            if (!erros.length) {
              this.fastUrlImageToBase64(this.$store.state.fastPlataforma.logo_plataforma, (myBase64) => {
                if (myBase64) {
                  contrato = contrato.replaceAll(
                    "%img_logo_plataforma%",
                    `<img src="${myBase64}" class="mw-100" style="max-height: 100px">`
                  )
                } else {
                  contrato = contrato.replaceAll(
                    "%img_logo_plataforma%",
                    ``
                  )
                }
                contrato = contrato.replaceAll(
                  "%nome_aluno%",
                  objPessoa.nome_razao.trim() + " " + objPessoa.sobrenome_fantasia.trim()
                )
                contrato = contrato.replaceAll(
                  "%cpf_aluno%",
                  objPessoa.cpf_cnpj.trim()
                )
                contrato = contrato.replaceAll(
                  "%naturalidade_aluno%",
                  objPessoa.cidade.trim() + "/" + objPessoa.uf.trim()
                )
                contrato = contrato.replaceAll(
                  "%nascimento_aluno%",
                  this.formataDataT(objPessoa.datanascimento_abertura.trim())
                )
                contrato = contrato.replaceAll(
                  "%nacionalidade_aluno%",
                  'Brasileira'
                )
                contrato = contrato.replaceAll(
                  "%nome_curso%",
                  fast_secretaria_curso.nome_curso
                )
                if (fast_secretaria_curso.nivel) {
                  contrato = contrato.replaceAll(
                    "%nivel_curso%",
                    this.retornaCursoNivel(fast_secretaria_curso.nivel)
                  )
                } else {
                  contrato = contrato.replaceAll(
                    "%nivel_curso%",
                    ''
                  )
                }
                if (fast_secretaria_curso.descricao_legal) {
                  contrato = contrato.replaceAll(
                    "%descricao_legal%",
                    fast_secretaria_curso.descricao_legal.trim()
                  )
                } else {
                  contrato = contrato.replaceAll(
                    "%descricao_legal%",
                    ''
                  )
                }
                // Dados das unidades
                let html_tbody_boletim = ``
                this.getHistoricoAluno(this.$route.params.id_plataforma, fast_secretaria_curso.id_secretaria_curso)
                  .then((res) => {
                    console.log("this.getHistoricoAluno externo", res)
                    this.fastHistoricoAluno = res
                    return this.promiseGetFastApi("api/fast_secretaria_curso/lista_historico", `id_plataforma=${this.$route.params.id_plataforma}&id_pessoa_aluno=${this.$store.state.fastPermissoes.id_pessoa}&id_secretaria_curso=${fast_secretaria_curso.id_secretaria_curso}`)
                  })
                  .then(res => {
                    //console.log("api/fast_secretaria_curso/lista_historico", res)   
                    this.$store.state.fastCarregando = false
                    if (res.length) {
                      let modulos = []
                      res.forEach((e) => {
                        modulos.push(e.id_secretaria_curso_programa);
                      })
                      // Remove valores duplicados do array
                      modulos = modulos.filter(
                        (a, b) => modulos.indexOf(a) === b
                      )
                      modulos.forEach((id_secretaria_curso_programa, index) => {
                        let sigla_programa = ""
                        res.forEach(e => {
                          if (e.id_secretaria_curso_programa == id_secretaria_curso_programa) {
                            sigla_programa = e.sigla_programa
                          }
                        })
                        html_tbody_boletim += `<tr><td colspan="7"><b>${sigla_programa}</b></td></tr><tr>`
                        res.forEach(u => {
                          if (u.id_secretaria_curso_programa == id_secretaria_curso_programa) {
                            let historico_externo = false
                            this.fastHistoricoAluno.forEach(h => {
                              if (h.id_curso == u.id_curso) {
                                historico_externo = true
                                html_tbody_boletim += `<tr>`
                                html_tbody_boletim += `<td>${h.ano ? h.ano : ''}</td><td>${h.nome_curso}</td><td>-</td><td>-</td><td>${h.carga_horaria_unidade ? h.carga_horaria_unidade + 'h' : ''}</td>`
                                html_tbody_boletim += `<td>${h.nota_unidade ? h.nota_unidade : '-'}</td>`
                                html_tbody_boletim += `<td>${h.nome_tipo_resultado ? h.nome_tipo_resultado : ''}</td>`
                                html_tbody_boletim += `</tr>`
                              }
                            })
                            if (!historico_externo) {
                              html_tbody_boletim += `<tr>`
                              html_tbody_boletim += `<td>${u.data_final_uc ? u.data_final_uc.split("-")[0] : '-'}</td><td>${u.nome_unidade}</td><td>-</td><td>-</td><td>${u.carga_horaria_unidade ? u.carga_horaria_unidade + 'h' : ''}</td>`
                              html_tbody_boletim += `<td>${u.nota_final && u.possui_avaliacao ? u.nota_final : '-'}</td>`
                              let aprovado = u.aprovado ? "APROVADO" : "REPROVADO"
                              if (!u.possui_avaliacao && (u.porcentagem_unidade < 100 && u.aprovado == 0)) aprovado = "PENDENTE"
                              else if (u.possui_avaliacao && !u.nota_final) aprovado = "PENDENTE"
                              html_tbody_boletim += `<td>${aprovado}</td>`
                              html_tbody_boletim += `</tr>`
                            }
                          }
                        })
                        html_tbody_boletim += `</tr>`
                      })
                      contrato = contrato.replaceAll(
                        "%tbody_boletim%",
                        html_tbody_boletim
                      )
                      // Gera pdf
                      console.log("this.boletim_html_template", this.boletim_html_template)
                      this.boletim_html_template = contrato;
                      this.$refs.html2PdfHistorico.generatePdf()
                      this.$store.state.fastCarregando = false
                    } else if (this.fastHistoricoAluno.length) {
                      console.log("Aluno só possui histórico externo")
                      this.exibeToasty("Nenhum histórico encontrado", "error")
                    } else {
                      this.exibeToasty("Nenhum histórico encontrado", "error")
                    }
                  })
                  .catch(e => {
                    this.exibeToasty(e, "error")
                    console.log(e)
                    this.$store.state.fastCarregando = false
                  })
              })
            } else {
              erros.forEach(e => this.exibeToasty(e, "error"))
              this.$store.state.fastCarregando = false;
            }
          } else {
            this.exibeToasty("Erro ao buscar dados do aluno", "error");
            this.$store.state.fastCarregando = false;
          }
        }).catch(e => {
          console.log(e);
          this.exibeToasty("Erro ao buscar dados do aluno", "error");
          this.$store.state.fastCarregando = false;
        })
    },
    getHistoricoAluno(id_plataforma, id_secretaria_curso) {
      return new Promise(async (resolve, reject) => {
        this.promiseGetFastApi("api/fast_secretaria_aluno_historico_escolar/lista", "id_plataforma=" + id_plataforma + "&id_secretaria_curso=" + id_secretaria_curso).then(json => {
          let obj = Array.from(json)
          resolve(obj);
          return true;
        }).catch(e => {
          reject(true)
          return false
        })
      });
    },
    gerarCertificadoConclusao(fast_secretaria_curso) {
      let erros = []
      //let fast_secretaria_curso = this.fastSecretariaCertificadoCurso
      this.fastSecretariaCertificadoCurso = fast_secretaria_curso
      let contrato = this.htmlCertificado;

      this.$store.state.fastCarregando = true
      this.promiseGetFastApi("api/fast_plataforma_usuario/busca_pessoa_secretaria", "id_pessoa=" + this.$store.state.fastPermissoes.id_pessoa + "&id_plataforma=" + this.$route.params.id_plataforma)
        .then(obj => {
          let objPessoa = JSON.parse(obj)
          //console.log("objPessoa", objPessoa)
          if (objPessoa.id_pessoa) {
            if (this.boletim_html_template.indexOf("%nome_aluno%") != "-1" && !objPessoa.nome_razao) erros.push("O nome do aluno não foi cadastrado")
            if (this.boletim_html_template.indexOf("%nome_aluno%") != "-1" && !objPessoa.sobrenome_fantasia) erros.push("O sobrenome do aluno não foi cadastrado")
            if (this.boletim_html_template.indexOf("%cpf_aluno%") != "-1" && !objPessoa.cpf_cnpj) erros.push("O CPF do aluno não foi cadastrado")
            if (this.boletim_html_template.indexOf("%naturalidade_aluno%") != "-1" && !objPessoa.cidade) erros.push("O cidade do aluno não foi cadastrada")
            if (this.boletim_html_template.indexOf("%naturalidade_aluno%") != "-1" && !objPessoa.uf) erros.push("O estado do aluno não foi cadastrado")
            if (this.boletim_html_template.indexOf("%nascimento_aluno%") != "-1" && !objPessoa.datanascimento_abertura) erros.push("A data de nascimento do aluno não foi cadastrada")
            if (this.boletim_html_template.indexOf("%nome_curso%") != "-1" && !fast_secretaria_curso.nome_curso) erros.push("O nome do curso não foi identificado")

            if (!erros.length) {
              contrato = contrato.replaceAll(
                "%nome_plataforma%",
                this.$store.state.fastPlataforma.nome_plataforma
              )
              console.log("this.$store.state.fastPlataforma.logo_plataforma", this.$store.state.fastPlataforma.logo_plataforma)
              this.fastUrlImageToBase64(this.$store.state.fastPlataforma.logo_plataforma, (myBase64) => {
                if (myBase64) {
                  contrato = contrato.replaceAll(
                    "%img_logo_plataforma%",
                    `<img src="${myBase64}" class="mw-100" style="max-height: 100px">`
                  )
                } else {
                  contrato = contrato.replaceAll(
                    "%img_logo_plataforma%",
                    ``
                  )
                }


                contrato = contrato.replaceAll(
                  "%nome_aluno%",
                  objPessoa.nome_razao.trim() + " " + objPessoa.sobrenome_fantasia.trim()
                )
                contrato = contrato.replaceAll(
                  "%cpf_aluno%",
                  objPessoa.cpf_cnpj.trim()
                )
                contrato = contrato.replaceAll(
                  "%naturalidade_aluno%",
                  objPessoa.cidade.trim() + "/" + objPessoa.uf.trim()
                )
                contrato = contrato.replaceAll(
                  "%nascimento_aluno%",
                  this.formataDataT(objPessoa.datanascimento_abertura.trim())
                )
                contrato = contrato.replaceAll(
                  "%nacionalidade_aluno%",
                  'Brasileira'
                )
                contrato = contrato.replaceAll(
                  "%nome_curso%",
                  fast_secretaria_curso.nome_curso
                )
                if (fast_secretaria_curso.nivel) {
                  contrato = contrato.replaceAll(
                    "%nivel_curso%",
                    this.retornaCursoNivel(fast_secretaria_curso.nivel)
                  )
                } else {
                  contrato = contrato.replaceAll(
                    "%nivel_curso%",
                    ''
                  )
                }

                if (fast_secretaria_curso.descricao_legal) {
                  contrato = contrato.replaceAll(
                    "%descricao_legal%",
                    fast_secretaria_curso.descricao_legal.trim()
                  )
                } else {
                  contrato = contrato.replaceAll(
                    "%descricao_legal%",
                    ''
                  )
                }

                // Informações da empresa
                this.promiseGetFastApi("api/fast_plataforma/lista_responsavel", "id_plataforma=" + this.$route.params.id_plataforma)
                  .then(res => {
                    console.log("lista_responsavel", res)
                    if (res.length) {
                      console.log("res[0].logradouro", res[0].logradouro)
                      contrato = contrato.replaceAll(
                        "%logradouro_empresa%",
                        res[0].logradouro
                      )
                      contrato = contrato.replaceAll(
                        "%numero_empresa%",
                        res[0].numero
                      )
                      contrato = contrato.replaceAll(
                        "%complemento_empresa%",
                        res[0].complemento
                      )
                      contrato = contrato.replaceAll(
                        "%cidade_empresa%",
                        res[0].cidade
                      )
                      contrato = contrato.replaceAll(
                        "%uf_empresa%",
                        res[0].uf
                      )
                      contrato = contrato.replaceAll(
                        "%cep_empresa%",
                        res[0].cep
                      )
                      contrato = contrato.replaceAll(
                        "%email_empresa%",
                        res[0].email
                      )
                      contrato = contrato.replaceAll(
                        "%telefone_empresa%",
                        res[0].telefone
                      )
                    } else {
                      this.exibeToasty("Configure o responsável pela plataforma", "error")
                    }

                  })
                  .then(() => {
                    // Gera pdf
                    //console.log("this.htmlCertificado", this.htmlCertificado)
                    this.htmlCertificado = contrato;
                    this.$refs.html2PdfCertificado.generatePdf()
                    this.$store.state.fastCarregando = false
                  })
                  .catch(e => {
                    this.$store.state.fastCarregando = false;
                    this.exibeToasty(e, "error")
                  })

              })

            } else {
              erros.forEach(e => this.exibeToasty(e, "error"))
              this.$store.state.fastCarregando = false;
            }
          } else {
            this.exibeToasty("Erro ao buscar dados do aluno", "error");
            this.$store.state.fastCarregando = false;
          }
        }).catch(e => {
          console.log(e);
          this.exibeToasty("Erro ao buscar dados do aluno", "error");
          this.$store.state.fastCarregando = false;
        })
    }
  },
};
</script>

<style>
</style>